<template>
  <div class="contact-page">
    <!-- 1. 顶部Banner（复用公司介绍页Banner） -->
    <section class="hidden md:block relative w-full overflow-hidden">
      <img src="@/assets/about/Rectangle_50.png" alt="北京菌丰生物科技有限公司" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">北京菌丰生物科技有限公司</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          农菌+科技双轮驱动，菌菇产业迎黄金增长期</p>
      </div>
    </section>

    <!-- 2. 联系表单内容区 -->
    <section class="md:py-16 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <!-- 标题区 -->
      <div class="text-center mb-12">
        <div class=" text-center md:hidden mt-6">

          <svg t="1776758926412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="2504" width="24" height="24">
            <path
              d="M660.8 959.6c-31.7 0-62.4-6.2-91.4-18.4-28-11.8-53.1-28.8-74.7-50.3-21.6-21.6-38.5-46.7-50.3-74.7-12.3-29-18.4-59.7-18.4-91.4 0-31.7 6.2-62.4 18.4-91.4 11.8-28 28.8-53.1 50.3-74.7 21.6-21.6 46.7-38.5 74.7-50.3 29-12.3 59.7-18.4 91.4-18.4 31.7 0 62.4 6.2 91.4 18.4 28 11.8 53.1 28.8 74.7 50.3 21.6 21.6 38.5 46.7 50.3 74.7 12.3 29 18.4 59.7 18.4 91.4 0 31.7-6.2 62.4-18.4 91.4-11.8 28-28.8 53.1-50.3 74.7-21.6 21.6-46.7 38.5-74.7 50.3-29 12.1-59.8 18.4-91.4 18.4z m0-437.5c-54.1 0-105 21.1-143.3 59.3-38.3 38.2-59.3 89.2-59.3 143.3 0 54.1 21.1 105 59.3 143.3 38.2 38.3 89.2 59.3 143.3 59.3 54.1 0 105-21.1 143.3-59.3 38.3-38.2 59.3-89.1 59.3-143.3 0-54.2-21.1-105-59.3-143.3-38.3-38.3-89.2-59.3-143.3-59.3z m0 0"
              p-id="2505" fill="#41B56F"></path>
            <path
              d="M739.9 757.3h-78.4c-8.9 0-16.1-7.2-16.1-16.1V596.3c0-8.9 7.2-16.1 16.1-16.1 8.9 0 16.1 7.2 16.1 16.1v128.8h62.3c8.9 0 16.1 7.2 16.1 16.1 0 9-7.2 16.1-16.1 16.1z m0 0"
              p-id="2506" fill="#41B56F"></path>
            <path
              d="M175.8 145.8h7.2c2.8 0 5.5 1.4 7.1 3.7l64.7 94.1h0.7v-89.3c0-4.7 3.8-8.6 8.6-8.6h3c4.7 0 8.6 3.8 8.6 8.6v114.5c0 4.7-3.8 8.6-8.6 8.6h-6.5c-2.8 0-5.5-1.4-7.1-3.7L188 178.4h-0.7v90.4c0 4.7-3.8 8.6-8.6 8.6h-3c-4.7 0-8.6-3.8-8.6-8.6V154.4c0.1-4.7 4-8.6 8.7-8.6zM310.2 145.8h77.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-57.3c-4.7 0-8.6 3.8-8.6 8.6v21.2c0 4.7 3.8 8.6 8.6 8.6h52.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-52.9c-4.7 0-8.6 3.8-8.6 8.6v24.7c0 4.7 3.8 8.6 8.6 8.6h60.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-80.5c-4.7 0-8.6-3.8-8.6-8.6V154.4c-0.1-4.7 3.7-8.6 8.5-8.6zM423.7 145.8c3.9 0 7.4 2.7 8.3 6.5l24 96h0.7l25.2-96.1c1-3.8 4.4-6.4 8.3-6.4h7.8c3.9 0 7.3 2.6 8.3 6.4l25.2 96.1h0.7l24-96c1-3.8 4.4-6.5 8.3-6.5h4.6c5.7 0 9.8 5.5 8.2 10.9l-33 114.5c-1.1 3.7-4.4 6.2-8.2 6.2h-8.3c-3.9 0-7.3-2.6-8.3-6.4l-25-95.2h-0.7l-25 95.2c-1 3.8-4.4 6.4-8.3 6.4H452c-3.8 0-7.2-2.5-8.2-6.2l-32.9-114.5c-1.6-5.5 2.5-10.9 8.2-10.9h4.6zM568.3 398.9h-400c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h400c0.6 0 1.1 0.5 1.1 1.1v9.5c0 0.6-0.5 1.1-1.1 1.1zM343.2 513.8H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1zM343.2 628.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.7-0.4 1.1-1 1.1zM343.2 743.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1z"
              fill="#41B56F" p-id="2507"></path>
            <path
              d="M350.7 900.6c0-7-5.6-12.6-12.6-12.6H128.5c-18.2 0-33.1-13.7-33.1-30.6V122.7c0-16.9 14.8-30.6 33.1-30.6h488c18.2 0 33.1 13.7 33.1 30.6v297.9c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V122.7c0-30.8-27-55.9-60.3-55.9h-488c-33.2 0-60.3 25.1-60.3 55.9v734.6c0 30.8 27 55.9 60.3 55.9h209.6c6.9 0 12.6-5.7 12.6-12.6z"
              fill="#41B56F" p-id="2508"></path>
          </svg>
        </div>
        <h3 class="md:text-2xl text-lg font-bold text-[#41B56F] md:mb-4">在线联系</h3>
        <p class="text-[#666] text-base max-w-2xl mx-auto hidden md:block">
          以专业的技术团队，优质的产品供应和完善的售后保障，<br>
          为客户提供从菌种选育、种植指导到产品加工销售的一站式解决方案。
        </p>
      </div>

      <!-- 联系表单 -->
      <div class="md:space-y-6">
        <!-- 姓名和电话行 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <el-input placeholder="姓名" prefix-icon="el-icon-user" v-model="input2">
          </el-input>
          <el-input placeholder="电话" prefix-icon="el-icon-phone-outline" v-model="input2">
          </el-input>
        </div>
        <!-- 留言输入 -->
        <div class="relative mt-6">
          <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 10 }" prefix-icon="el-icon-chat-dot-square"
            placeholder="留言" v-model="textarea">
          </el-input>
        </div>
        <!-- 提交按钮 -->
        <button class="md:w-full mx-auto block w-1/2 mb-10 mt-6 md:mb-0  bg-[#41B56F] text-white py-4 rounded hover:bg-green-700 transition md:text-xl">
          点击提交
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ContactPage"
}
</script>

<style scoped>
/* 基础过渡效果 */
input,
textarea {
  transition: border-color 0.3s ease;
}

button {
  border: none;
  cursor: pointer;
}
</style>